if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (window.giftAuto) {
                const giftId = window.giftProdId;
                const giftInput = this.cart.querySelector('input[data-gift-id="' + giftId + '"]');
                if (giftInput) {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.addGiftItem(giftId);
                  });
                } else {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                }
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

class ProductStickyAtcButton extends HTMLElement {
  constructor() {
    super();
    // Bind the variant change handler
    this.variantChangeHandler = this.updateStickyAtc.bind(this);
  }

  connectedCallback() {
    this.observeProductForm();
    // Listen for variant changes
    this.listenForVariantChange();
  }

  observeProductForm() {
    const productForm = document.querySelector('.product__info-wrapper .product-form');
    const footerContent = document.querySelector('.footer__content-bottom');
    const stickyAtc = document.querySelector('product-sticky-atc-button');
    const compStyles = window.getComputedStyle(footerContent);
    let stickyHeader = document.querySelector('sticky-header, sticky-simple-header');

    if (null === stickyHeader) {
      stickyHeader = document.querySelector('header.header');
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const productFormRect = productForm.getBoundingClientRect();

        if (entry.intersectionRatio === 0 && productFormRect.top + productFormRect.height <= stickyHeader.getBoundingClientRect().height) {
          this.classList.add('atc-active');
          footerContent.style.paddingBottom = compStyles.getPropertyValue('padding-bottom');

        } else {
          this.classList.remove('atc-active');
          footerContent.style.paddingBottom = `${stickyAtc.getBoundingClientRect().height}px`;
        }
      });
    }, { root: null, threshold: 0 });

    observer.observe(productForm);
  }

  listenForVariantChange() {
    subscribe(PUB_SUB_EVENTS.variantChange, this.variantChangeHandler);
  }

  updateStickyAtc({ data: { variant, html } }) {
    if (!variant) return;

    // Update hidden input
    const input = this.querySelector('input[name="id"]');
    if (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update price
    const priceContainer = this.querySelector('.sticky-atc-button-details .price--sticky');
    if (priceContainer) {
      const newPrice = html && html.querySelector('.sticky-atc-button-details .price--sticky');
      if (newPrice) {
        priceContainer.className = newPrice.className;
        priceContainer.innerHTML = newPrice.innerHTML;
      } else {
        priceContainer.innerHTML = variant.price ? formatMoney(variant.price, '{{amount}} €').replace('.', ',') : 'Ausverkauft';
      }
    }

    // Update media
    const img = this.querySelector('.sticky-atc-button-img img');
    if (img && variant.featured_image) {
      img.src = variant.featured_image.src;
      img.alt = variant.featured_image.alt || '';
    }

    // Optionally update title or other details
    const title = this.querySelector('.sticky-atc-button-title');
    if (title) {
      title.textContent = variant.name || 'Unnamed Variant';
    }
  }
}

// Define custom formatMoney function
function formatMoney(cents, format = "${{amount}}") {
  if (typeof cents === "string") cents = cents.replace(".", "");
  const value = cents / 100;
  return format.replace("{{amount}}", value.toFixed(2));
}

customElements.define('product-sticky-atc-button', ProductStickyAtcButton);

class SizeChartModal extends ModalDialog {
  constructor() {
    super();


  }
}

customElements.define('size-chart-modal', SizeChartModal);

class CopyDiscountCode extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.copy-discount-code__button');
    this.discountCodeText = this.querySelector('.copy-discount-code__button-text');

    if (this.button) {
      this.button.addEventListener('click', this.copyToClipboard.bind(this));
    }
  }

  copyToClipboard() {
    if (!this.discountCodeText) return;

    const discountCode = this.discountCodeText.textContent.trim();

    navigator.clipboard.writeText(discountCode)
      .then(() => {
        // Provide feedback to the user (optional)
        this.showFeedback();
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
        this.showFeedback('Failed to copy the discount code.');
      });
  }

  showFeedback() {
    const originalText = this.discountCodeText.textContent.trim();
    const successText = this.button.getAttribute('data-success-text');

    this.discountCodeText.textContent = successText;

    setTimeout(() => {
      this.discountCodeText.textContent = originalText;
    }, 2000);
  }
}

customElements.define('copy-discount-code', CopyDiscountCode);